/**
 * @requires $state ngDialog addRights mainCons app
 * @description 使用此指令显示可添加的服务列表并执行添加操作
 * @example <div show-rights>点击添加权益</div>
 */

define('directives/myreport/eCharts.directives',['app', 'echarts-all'], function (app, eCharts) {
    return app.directive('eCharts', ['$timeout',function ($timeout) {
        return {
            restrict: 'E',
            scope: {
                conf: "=",
                magicType:"="
            },
            replace: true,
            templateUrl: '../refactor/directives/myreport/eCharts.template.html',
            link: function ($scope, $element, $attr) {
                var legendDefault = '消耗金额';
                var myChart;
                $element.attr("id",$scope.conf.id);
                if($scope.conf.width){
                    $element.width($scope.conf.width);
                }
                if($scope.conf.height){
                    $element.find(".reportContent").height($scope.conf.height);
                }
                $element.find(".reportContent").hide();
                $element.find(".section-content").hide();

                $scope.$watch('conf',function (newVal, oldVal){
                    // 如果需要在最一开始就画报表，则属性load-at-beginning需要设置为true，此时用不检查图表内容
                    if(arguments[0] == arguments[1] && $attr.loadAtBeginning != "true"　){
                        return ;
                    }
                    // 单独启动一个线程，处理报表的初始化
                    $timeout(function(){
                        if (myChart && myChart.dispose) {
                            myChart.dispose();
                            myChart = null;
                        }
                        if($scope.conf.options && $scope.conf.options.xAxis[0].data.length > 0){
                            $element.find(".reportContent").show();
                            $element.find(".section-content").hide();
                            // 基于准备好的dom，初始化echarts图表
                            var section = $element.parents("section");
                            var allCharts = section.find(".reportContent");
                            myChart = eCharts.init($element.find(".reportContent")[0]);
                            window.onresize = function () {
                                window["eCharteResizeLastParam"] = arguments;
                                for(var i=0;i<allCharts.length;i++){
                                    //如果当前图表未被隐藏，才需要resize，防止页签切换后缩放页面导致图表变形
                                    if (angular.element(allCharts[i]).parents(".ng-hide").length == 0) {
                                        eCharts.init(allCharts[i]).resize.apply(this, window["eCharteResizeLastParam"]);
                                    }
                                }
                            };
                            var toOptions = getOptions();
                            var dataType;
                            //报表重绘之后不会保留之前选中的图表类型，手动再赋值一遍
                            if($scope.changeMagictype){
                                dataType = $scope.changeMagictype;
                            }else{
                                dataType = $scope.magicType;

                            }
                            angular.forEach($scope.conf.options.series,function (v) {
                               v.type = dataType;
                            });

                            //解决报表切成折线图之后再点击还原，折现不会从原点开始的问题
                            if($scope.magicType == 'line'){
                                angular.forEach($scope.conf.options.xAxis,function(v){
                                    v. boundaryGap = false;
                                });
                            }


                            AUI.BaseJSUtil.mergeJSON($scope.conf.options, toOptions);
                            // 统一设置Y轴数据过大的格式；比如100000000 => 1.00亿
                            if(!$scope.conf.noFormatAxisLabel){
                                for(var index in toOptions.yAxis){
                                    toOptions.yAxis[index].axisLabel= {
                                        formatter: function (v) {
                                            return numFormat(v)
                                        }
                                    };
                                }
                            }
                            if($scope.conf.options.legend.data && $scope.conf.options.legend.data.length>0){
                                legendDefault = $scope.conf.options.legend.data[0];
                            }
                            // 为echarts对象加载数据
                            myChart.setOption(toOptions, true);
                            myChart.on('magicTypeChanged',function(param){
                                $scope.changeMagictype = $scope.magicType = param.currentType;

                            });
                            // 应用统计特殊处理，需要切换右边Y轴的标题
                            if($scope.conf.legendSelectedFun){
                                // 给图例按钮 增加切换事件
                                myChart.on('legendSelected', function (param){
                                    toOptions.yAxis[1].name = param.target;
                                    myChart.setOption(toOptions, true);
                                });
                                // 给还原按钮 增加事件
                                myChart.on('restore', function (){
                                    if(legendDefault){
                                        toOptions.yAxis[1].name = legendDefault;
                                        myChart.setOption(toOptions, true);
                                    }
                                });
                            }
                        }else{
                            $element.find(".reportContent").hide();
                            $element.find(".section-content").show();
                        }
                    },100);
                },true);

                function numFormat(num) {
                    var p;
                    if(angular.isNumber(num)){
                        if (num >= 1000000000000) {
                            p = num / 1000000000000;
                            return p.toFixed(2) + "万亿";
                        }
                        else if (num >= 100000000) {
                            p = num / 100000000;
                            return p.toFixed(2) + "亿";
                        }
                        else if (num >= 10000) {
                            p = num / 10000;
                            return p.toFixed(2) + "万";
                        }
                        else {
                            return num;
                        }
                    }else{
                        return 0;
                    }

                }

                function getOptions(){
                    return {
                        color: ['#ff7f50','#87cefa','#da70d6','#32cd32','#6495ed',
                            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
                            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
                            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
                        tooltip: {
                            show: true,
                            backgroundColor: 'rgba(50,50,50,0.7)',
                            trigger: 'axis',
                            axisPointer: {
                                type: 'line',
                                crossStyle: {
                                    color: '#008acd'
                                },
                                shadowStyle: {
                                    color: 'rgba(200,200,200,0.2)'
                                },
                                lineStyle: {
                                    color: '#008acd'
                                }
                            }
                        },
                        grid: {
                            left: '10%',
                            right: '10%',
                            containLabel: true
                        },
                        toolbox: {
                            show : true,
                            feature : {
                                magicType : {show: true, type: ['line', 'bar']},
                                restore: {show: true},
                            }
                        },
                        dataZoom : {
                            show : true,
                            realtime : true,
                            start : 0,
                            end : 100
                        }
                    };
                }
            }
        };
    }]);
});

